import React from "react";
import { useTranslation } from "react-i18next";
import StatusDeposit from "./StatusDeposit";
import { EDepositStatus } from "src/types";

const DepositError: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  
  return (
    <StatusDeposit
      status={EDepositStatus.Error}
      title={t("DEPOSIT_STATUS.DEPOSIT_FAILED")}
      message={t("DEPOSIT_STATUS.DEPOSIT_ERROR_TRY_AGAIN")}
    />
  );
};

export default DepositError;
